import { Table } from 'antd'
import React from 'react'
import deploymentInformation from 'constant/deployment-information'
import columns from './columns'

const DeploymentInformation = () => {
  return (
    <div className='about-scrollable'>
      <Table
        className='about-tables'
        columns={columns}
        dataSource={deploymentInformation}
        pagination={false}
      />
    </div>
  )
}

export default DeploymentInformation
